import AttachmentField from "components/molecules/AttachmentField";
import FormDomainDataPicklistField from "containers/FormDomainDataPicklistField";
import FormBooleanField from "../FormBooleanField";
import FormCurrencyField from "../FormCurrencyField";
import FormDateDayField from "../FormDateDayField";
import FormDateField from "../FormDateField";
import FormDateMonthField from "../FormDateMonthField";
import FormDateTimeField from "../FormDateTimeField";
import FormDateYearField from "../FormDateYearField";
import FormEmailField from "../FormEmailField";
import FormFloatField from "../FormFloatField";
import FormIntegerField from "../FormIntegerField";
import FormLatitudeField from "../FormLatitudeField";
import FormLatLongField from "../FormLatLongField";
import FormLongitudeField from "../FormLongitudeField";
import FormPhoneField from "../FormPhoneField";
import FormPicklistField from "../FormPicklistField";
import FormStringField from "../FormStringField";
import FormTimeField from "../FormTimeField";
import FormUrlField from "../FormUrlField";

/** @type {import('./types').IFormFieldProps} */
const FormField = ({ dataType, disabled, ...props }) => {
    const commonProps = { disabled, ...props };
    switch (dataType) {
        case "integer":
            return <FormIntegerField {...commonProps} />;
        case "float":
            return <FormFloatField {...commonProps} />;
        case "string":
            return <FormStringField {...commonProps} />;
        case "boolean":
            return <FormBooleanField {...commonProps} />;
        case "datetime":
            return <FormDateTimeField {...commonProps} />;
        case "date":
            return <FormDateField {...commonProps} />;
        case "time":
            return <FormTimeField {...commonProps} />;
        case "date-year":
            return <FormDateYearField {...commonProps} />;
        case "date-month":
            return <FormDateMonthField {...commonProps} />;
        case "date-day":
            return <FormDateDayField {...commonProps} />;
        case "currency":
            return <FormCurrencyField {...commonProps} />;
        case "picklist":
            if (props.picklistType === "static") {
                return <FormPicklistField items={props.staticPicklist} fetchingData={false} {...commonProps} />;
            } else if (props.picklistType === "dynamic") {
                return <FormDomainDataPicklistField {...commonProps} />;
            }
            return <FormPicklistField items={[]} fetchingData={false} {...commonProps} />;
        case "email":
            return <FormEmailField {...commonProps} />;
        case "url":
            return <FormUrlField {...commonProps} />;
        case "phone":
            return <FormPhoneField {...commonProps} />;
        case "latlng":
            return <FormLatLongField precision={props.precision} format="decimal" separator="," {...commonProps} />;
        case "latitude":
            return <FormLatitudeField precision={props.latitudePrecision} {...commonProps} />;
        case "longitude":
            return <FormLongitudeField precision={props.longitudePrecision} {...commonProps} />;
        case "attachment":
            props.dataType = "attachment";
            return <AttachmentField {...commonProps} />;
        case "image":
            props.dataType = "image";
            return <AttachmentField {...commonProps} />;
        case "document":
            props.dataType = "document";
            return <AttachmentField {...commonProps} />;
        default:
            return <FormStringField {...commonProps} />;
    }
};

export default FormField;
